var React = require('react');

function Header (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,1,-470.074,-743.966)"},React.createElement("g",{"transform":"matrix(2,0,0,1.651,429.213,575.27)"},React.createElement("g",{"transform":"matrix(0.5,0,0,0.605692,-214.607,-348.437)"},React.createElement("path",{"d":"M470.074,770.903L1451.98,770.996L1451.98,761.141L1342.88,761.141L1342.88,752.545L1233.78,752.545L1233.78,761.141L1124.68,761.141L1124.68,768L1015.58,768L1015.58,761.141L906.476,761.141L906.476,752.545L797.375,752.545L797.375,743.966L688.275,743.966L688.275,752.545L579.174,752.545L579.174,761.141L470.074,761.141L470.074,770.903Z"})))));
}

Header.defaultProps = {"width":"982","height":"40","preserveAspectRatio":"none","viewBox":"0 0 982 28","version":"1.1"};

module.exports = Header;

Header.default = Header;
